import { computed, PropType } from 'vue';

export type MpfContentAttrs = Record<string, unknown>;

export interface MpfContentTextNode {
  text: string;
}

export interface MpfContentElementNode {
  tag: string;
  text?: string;
  tagClasses?: string[];
  attrs?: MpfContentAttrs;
  children?: MpfContentNode[];
}

export type MpfContentNode = MpfContentTextNode | MpfContentElementNode;

export interface MpfContentRendererProps {
  contentData: MpfContentNode[];
  transformTo?: (to: string) => string;
}

export const mpfContentRendererProps = {
  contentData: {
    type: Array as PropType<MpfContentNode[]>,
    default: () => [],
  },
  transformTo: {
    type: Function as PropType<(to: string) => string>,
    default: undefined,
  },
};

export const defaultTagClasses = computed<Record<string, string[]>>(() => ({
  section: ['mpf-content-renderer__section'],
  h1: ['mpf-heading-l'],
  h2: ['mpf-heading-m'],
  h3: ['mpf-content-h3'],
  h4: ['mpf-content-h4'],
  h5: ['mpf-content-h5'],
  h6: ['mpf-content-h6'],
  p: ['mpf-content-p'],
  ul: ['mpf-content-ul'],
  ol: ['mpf-content-ol'],
  li: ['mpf-content-li'],
  a: ['mpf-content-link'],
  'router-link': ['mpf-content-link'],
  strong: ['mpf-content-strong'],
  em: ['mpf-content-em'],
  div: ['mpf-content-div'],
  span: ['mpf-content-span'],
}));
